import { useState, useEffect } from "react";
import { authAPI } from "../../../services/api";
import BackButton from "./BackButton";
import Alert from "../../common/Alert";
import { useAlert } from "../../../Hooks/useAlert";

function ProfileSettings() {
  const { showAlert, alertConfig } = useAlert();
  const currentUser = authAPI.getCurrentUser();

  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (currentUser) {
      setUserName(currentUser.userName || "");
      setEmail(currentUser.email || "");
      setMobileNo(currentUser.mobileNo || "");
    }
  }, [currentUser]);

  const handleSaveProfile = async () => {
    if (!userName.trim()) {
      await showAlert({
        type: "warning",
        title: "Validation Error",
        message: "Username is required",
      });
      return;
    }

    if (!mobileNo.trim()) {
      await showAlert({
        type: "warning",
        title: "Validation Error",
        message: "Mobile number is required",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await authAPI.updateProfile(userName, email, mobileNo);
      if (response.success) {
        // Update local storage with new values
        const stored = JSON.parse(localStorage.getItem("milkBillingUser")) || {};
        stored.userName = userName;
        stored.email = email;
        stored.mobileNo = mobileNo;
        localStorage.setItem("milkBillingUser", JSON.stringify(stored));

        await showAlert({
          type: "success",
          title: "Success",
          message: "Profile updated successfully!",
        });
      } else {
        await showAlert({
          type: "error",
          title: "Error",
          message: response.message || "Failed to update profile.",
        });
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      await showAlert({
        type: "error",
        title: "Error",
        message: error.response?.data?.message || "Failed to update profile.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="settings-page">
      <header className="settings-page-header">
        <BackButton to="/settings" section="general" />
        <h1 className="settings-page-title">Profile Settings</h1>
      </header>

      <main className="settings-page-content">
        <div className="settings-form-card">
          <div className="settings-form-body">
            <div className="settings-form-group">
              <label className="settings-form-label">Username</label>
              <input
                type="text"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                className="settings-form-input"
                placeholder="Enter username"
              />
            </div>

            <div className="settings-form-group">
              <label className="settings-form-label">Email <span className="text-gray-400">(optional)</span></label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="settings-form-input"
                placeholder="Enter email"
              />
            </div>

            <div className="settings-form-group">
              <label className="settings-form-label">Mobile Number</label>
              <input
                type="tel"
                value={mobileNo}
                onChange={(e) => setMobileNo(e.target.value)}
                className="settings-form-input"
                placeholder="Enter mobile number"
              />
            </div>

            <div className="settings-form-actions">
              <button
                type="button"
                onClick={handleSaveProfile}
                disabled={loading}
                className="settings-form-btn"
              >
                <i className="fas fa-save" />
                <span>{loading ? "Saving..." : "Save Changes"}</span>
              </button>
            </div>
          </div>
        </div>
      </main>

      {alertConfig && <Alert {...alertConfig} />}
    </div>
  );
}

export default ProfileSettings;
